import AwareComponent from '@af-common/Common/_components/AwareComponent'
import { Delete, ExpandLess, ExpandMore } from '@mui/icons-material'
import { ButtonBase, Card } from '@mui/material'
import * as React from 'react'
import { ModuleTypes } from '../../Module/_config/ModuleInfo'
import * as ModuleResolver from '../../Module/_config/ModuleResolver'
import ModuleIconContainer from '../_containers/ModuleIconContainer'

export type Props = {
	name?: string
	type?: ModuleTypes
	isClone: boolean
	isDragging: boolean
	moduleMouseDown: (module: string, coords: {x: number, y: number}) => void
	moduleId: string
	selected: boolean
	moduleCount: number
	selectModule?: Function
	removeModule?: Function
};

type State = {
	className: string
	contents: React.ComponentClass<{opened: boolean} & any>
	opened: boolean
}

export default class Module extends AwareComponent<Props, State> {
	private mouseUp: EventListener;

	state = {
		className: "",
		contents: null,
		opened: false,
	} as State

	componentDidMount(){
		const module = this.getResolvedModule()
		this.setState({
			className: module.className,
			contents: module.settingsContainer,
			opened: this.props.selected,
		})
	}

	componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
		if(!prevProps.selected && this.props.selected) {
			this.setState({
				opened: true,
			})
		}
	}

	componentWillUnmount(): void {
		this.removeEvents()
	}

	private addEvents = () => {
		document.addEventListener('mouseup', this.mouseUp);
	}

	private removeEvents = () => {
		document.removeEventListener('mouseup', this.mouseUp);
	}

	private onMouseDown(e:React.MouseEvent) {
		this.props.selectModule(this.props.moduleId);
		this.props.moduleMouseDown(this.props.moduleId, {x: e.clientX, y: e.clientY})
		this.addEvents()
	}

	private onToggle(e:React.MouseEvent){
		this.stopMouseEvent(e);
		this.setState({
			opened: !this.state.opened
		})
	}

	private onDelete = (e:React.MouseEvent) => {
		this.stopMouseEvent(e);
		this.props.removeModule(this.props.moduleId);
	};

	private stopMouseEvent = (e:React.MouseEvent) => {
		e.stopPropagation();
		this.props.selectModule(this.props.moduleId);
	};

	private getResolvedModule = ():{className: string, settingsContainer: React.ComponentClass} => {
		let module: ReturnType<typeof this.getResolvedModule> = {className: '', settingsContainer: null};
		ModuleResolver.ResolveFromType(this.props.type, (className:string, settingsContainer:React.ComponentClass) => {
			module.className = className;
			module.settingsContainer = settingsContainer;
		});
		return module;
	}
	
	render() {
		let className = "module module-" + (this.state.className || "default") + (this.props.selected ? " module-selected" : '');
		let icon = <ModuleIconContainer moduleId={this.props.moduleId}/>;
		const opened = this.props.selected && this.state.opened;

		let Contents = this.state.contents;

		// Clone is basically the same element but without events
		return <>{this.props.isClone ? 
				<Card className={className}>
					{ icon }<h3>{this.props.name}</h3>
					<Delete className="module-delete"/>
					<div onMouseDown={(e) => this.stopMouseEvent(e)}>
						{Contents && <div className={"module-content"+(opened ? "":" hide")}>{<Contents opened={opened} moduleId={this.props.moduleId}/>}</div>}
					</div>
					<ButtonBase className={"module-button module-handle"}>
						{ opened ? <ExpandLess /> : <ExpandMore /> }
					</ButtonBase>
				</Card>
			:
			<React.Fragment key={this.props.moduleId}>
				{this.props.isDragging ? 
					<div className="module-wrapper"><div className="mdc-card anal-probe mdc-card--outlined spacer module-empty" /></div> :
					<div className={"module-wrapper"}>
						<Card className={className} onMouseDown={(e:React.MouseEvent) => this.onMouseDown(e)}>
							{ icon }<h3>{this.props.name}</h3>
							<Delete className="module-delete" onClick={(e) => this.onDelete(e)} onMouseDown={(e:React.MouseEvent) => this.stopMouseEvent(e)}/>
							{Contents && <div className={"module-content"+(opened ? "":" hide")}>{<Contents opened={opened} moduleId={this.props.moduleId}/>}</div>}
							<ButtonBase className={"module-button module-handle"} onClick={(e:React.MouseEvent) => this.onToggle(e)} onMouseDown={(e:React.MouseEvent) => this.stopMouseEvent(e)}>
								{ opened ? <ExpandLess /> : <ExpandMore /> }
							</ButtonBase>
						</Card>
					</div>
				}
			</React.Fragment>
		}</>
	}
}